import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import FixedWidthContainer from 'components/FixedWidthContainer'
import { useTranslation } from 'react-i18next'

const DealerSignupSection = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        backgroundColor: '#F8F8F8',
        marginBottom: 0
      }}
    >
      <FixedWidthContainer>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '32px 0px'
          }}
        >
          <Typography
            variant='h2'
            sx={{
              fontSize: '36px',
              color: 'primary.main'
            }}
          >
            {t('dealerSignup.title')}
          </Typography>

          <Button
            variant='contained'
            sx={{
              padding: '8px 32px',
              fontSize: '14px'
            }}
            onClick={() => navigate('/signup')}
          >
            {t('dealerSignup.signUp')}
          </Button>
        </Box>
      </FixedWidthContainer>
    </Box>
  )
}

export default DealerSignupSection
